<template>
  <div class="games-tile">
    <div class="games-tile__image">
      <q-img
        v-if="'GameImage.url' in game"
        :src="game.GameImage.url"
        :alt="game.GameImage.alternativeText"
        class="games-tile__image--height"
        contain
      />
      <div class="games-tile__image--height games-tile__image--no-image" v-else>
        <q-icon size="lg" name="broken_image" class="q-mb-sm" />
        <span>No image available</span>
      </div>
    </div>
    <div class="games-tile__content">
      <div class="games-tile__title">
        <h2>{{ game.GameName }}<sup>TM</sup></h2>
      </div>
      <div class="games-tile__table">
        <div class="games-tile__table-column">
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Release Date</span
            ><span>{{ formatDate(game.ReleaseDate) }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Default Bet</span
            ><span>{{ formatCurrencyDecimal(game.DefBet) }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Minimum Total Bet</span
            ><span>{{ formatCurrencyDecimal(game.MinBet) }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Maximum Total Bet</span
            ><span>{{ formatCurrencyDecimal(game.MaxBet) }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Paylines</span
            ><span>{{ game.Lines }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Max Multiplier</span>
            <span>{{ formatStringCurrencyDecimal(game.Multiplier) }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Max Exposure</span
            ><span>{{ formatCurrencyDecimal(game.MaxExposure) }}</span>
          </div>
        </div>
        <div
          class="games-tile__table-column games-tile__table-column--hide-for-mobile"
        >
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">RTP</span
            ><span>{{ game.RTP }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Free Spins</span
            ><span>{{ trueFalse(game.FreeSpins) }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Volatility</span
            ><span>{{ formatTextLabel(game.Volatility) }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Bouns Buy</span
            ><span>{{ trueFalse(game.BonusBuy) }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Aggregator</span
            ><span>{{ game.aggregator.Name }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Provider</span
            ><span>{{ game.game_provider.ProviderName }}</span>
          </div>
          <div class="games-tile__table-row">
            <span class="games-tile__table-label">Game Layout</span
            ><span>{{ game.GameLayout }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="games-tile__actions">
      <q-btn
        color="secondary"
        unelevated
        label="Read More"
        @click="handleReadMoreClick(game.id, game.GameName)"
        no-caps
      />
      <q-btn
        :disable="!game.resolvedDemoUrl"
        :color="game.resolvedDemoUrl ? 'secondary' : 'grey'"
        unelevated
        outline
        label="Demo"
        no-caps
        @click="
          handleDemoClick(
            game.resolvedDemoUrl,
            game.openDemoInIframe,
            game.GameName
          )
        "
      >
      </q-btn>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/utils/formatDate";
import {
  formatStringCurrencyDecimal,
  formatCurrencyDecimal,
} from "@/utils/formatCurrency";
import { formatTextLabel } from "@/utils/formatText";
import { trueFalse } from "@/utils/formatBoolean";
export default {
  name: "AllGamesGameTile",
  props: {
    game: Object,
  },
  methods: {
    formatDate,
    formatStringCurrencyDecimal,
    formatCurrencyDecimal,
    formatTextLabel,
    trueFalse,
    handleReadMoreClick(gameId, gameName) {
      this.$emit("readMoreClick", gameId, gameName);
    },
    handleDemoClick(gameId, gameName, gameLaunchIframe) {
      this.$emit("demoClick", gameId, gameName, gameLaunchIframe);
    },
  },
};
</script>

<style lang="scss" scoped>
// New CSS Grid Layout
.games-tile {
  background: #ffffff;
  border: 1px solid #c8c8c8;
  box-shadow: 0px 4px 15px 5px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  height: 100%;
  min-height: 0;
  width: 100%;
  min-width: 0;
  display: grid;
  grid-template-areas: "image" "content" "actions";
  @media only screen and (min-width: 768px) {
    grid-template-columns: 40% 1fr;
    grid-template-areas: "image content" "actions content";
  }
  @media only screen and (min-width: 1300px) {
    grid-template-columns: 400px 1fr;
  }
  &__image {
    grid-area: image;
    min-width: 0;
    padding: 18px 15px 0;
    border-right: none;
    height: inherit;
    @media only screen and (min-width: 768px) {
      border-right: 1px solid #c8c8c8;
      padding: 20px;
    }
    &--height {
      height: 130px;
      @media only screen and (min-width: 768px) {
        height: 190px;
      }
    }
    &--no-image {
      border: 1px solid #808080;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  &__content {
    grid-area: content;
  }
  &__table {
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
  }
  &__table-column {
    width: 100%;
    min-width: 0;
    @media only screen and (min-width: 768px) {
      width: 50%;
    }
    &--hide-for-mobile {
      display: none;
      @media only screen and (min-width: 768px) {
        display: block;
      }
    }
  }
  &__table-row {
    display: flex;
    justify-content: space-between;
    padding: 7px 15px;
    @media only screen and (min-width: 768px) {
      padding: 7px 25px 7px 12px;
    }
    &:nth-child(even) {
      background: #f7f8f9;
    }
  }
  &__table-label {
    font-weight: bold;
    font-size: 14px;
  }
  &__title {
    display: flex;
    align-items: center;
    padding: 0 15px;
    min-height: 50px;
    border-bottom: 1px solid #c8c8c8;
    min-width: 0;
    @media only screen and (min-width: 768px) {
      padding: 0 12px;
    }
    h2 {
      font-style: normal;
      font-weight: bold;
      font-size: 21px;
      color: #272833;
      line-height: 1;
    }
    sup {
      font-size: 9px;
    }
  }
  &__actions {
    grid-area: actions;
    justify-content: center;
    padding: 0 20px 20px;
    button,
    a {
      width: 100%;
      margin: 8px;
    }
    @media only screen and (min-width: 768px) {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-right: 1px solid #c8c8c8;
      button,
      a {
        width: 50%;
      }
    }
  }
}

.body {
  &--dark {
    // New Games Library
    .games-tile {
      background: #353535;
      border: 1px solid #808080;
      box-shadow: 0px 4px 15px 5px rgba(0, 0, 0, 0.05);
      &__image {
        @media only screen and (min-width: 768px) {
          border-right: 1px solid #808080;
        }
        &--no-image {
          border: 1px solid #808080;
        }
      }
      &__table-row {
        &:nth-child(even) {
          background: #4b4b4b;
        }
      }
      &__title {
        border-bottom: 1px solid #808080;
        h2 {
          color: #ffffff;
        }
      }
      &__actions {
        @media only screen and (min-width: 768px) {
          border-right: 1px solid #808080;
        }
      }
    }
  }
}
</style>
